"use client";

import type { DayOfWeek } from "@/lib/types";
import {
  SELL_FORM_DAYS_OF_WEEK,
  SELL_FORM_HOURS_OF_DAY,
} from "@/lib/listing/sellFormConstants";

export interface PickupScheduleFieldsProps {
  pickupDays: DayOfWeek[];
  pickupStartHour: string;
  pickupEndHour: string;
  onDayToggle: (day: DayOfWeek) => void;
  onPickupStartHourChange: (hour: string) => void;
  onPickupEndHourChange: (hour: string) => void;
  /** When false, omits the section heading (e.g. when embedded in step 6). */
  showSectionHeading?: boolean;
  className?: string;
}

export default function PickupScheduleFields({
  pickupDays,
  pickupStartHour,
  pickupEndHour,
  onDayToggle,
  onPickupStartHourChange,
  onPickupEndHourChange,
  showSectionHeading = true,
  className = "",
}: PickupScheduleFieldsProps) {
  return (
    <div className={className}>
      {showSectionHeading ? (
        <h3 className="text-sm font-medium text-foreground mb-4">
          Pickup Availability{" "}
          <span className="text-text-light text-xs font-normal">
            (optional)
          </span>
        </h3>
      ) : null}
      <div className="space-y-4">
        <div>
          <label className="block mb-2 text-sm font-medium text-foreground">
            Available Days
          </label>
          <div className="flex flex-wrap gap-2">
            {SELL_FORM_DAYS_OF_WEEK.map((day) => (
              <button
                key={day.value}
                type="button"
                onClick={() => onDayToggle(day.value)}
                className={`px-4 py-2 text-sm rounded-md transition-colors ${
                  pickupDays.includes(day.value)
                    ? "bg-primary text-white"
                    : "bg-secondary text-foreground hover:bg-tertiary"
                }`}
                style={{ minWidth: "80px" }}
              >
                {day.label}
              </button>
            ))}
          </div>
        </div>
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block mb-2 text-sm font-medium text-foreground">
              Start Time
            </label>
            <select
              name="pickupStartHour"
              value={pickupStartHour}
              onChange={(e) => onPickupStartHourChange(e.target.value)}
              className="w-full p-2 border rounded-lg"
            >
              {SELL_FORM_HOURS_OF_DAY.map((hour) => (
                <option key={hour.value} value={hour.value}>
                  {hour.label}
                </option>
              ))}
            </select>
          </div>
          <div>
            <label className="block mb-2 text-sm font-medium text-foreground">
              End Time
            </label>
            <select
              name="pickupEndHour"
              value={pickupEndHour}
              onChange={(e) => onPickupEndHourChange(e.target.value)}
              className="w-full p-2 border rounded-lg"
            >
              {SELL_FORM_HOURS_OF_DAY.map((hour) => (
                <option key={hour.value} value={hour.value}>
                  {hour.label}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>
    </div>
  );
}
